import React, { useEffect, useState } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { useOutletContext, useNavigate, useParams } from "react-router-dom";
import $ from "jquery";
import toastr from "../../../utils/toast";

function AddDesignation({ onClose }) {
  const { setGlobalLoading, token } = useOutletContext();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();
  
  const {
      register,
      handleSubmit,
      watch,
      setValue,
      unregister,
      formState: { errors },
    } = useForm();
  const [subDepartment, setsubDepartment] = useState([]);
  
  useEffect(() => {
    async function fetchAllDropdownData() {
      setGlobalLoading(false); //  Show loader before API call
      try {
        const res = await axios.get(`${API_BASE_URL}/settings/get_sub_department_list`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      //  const data = res.data;
        setsubDepartment(res.data.sub_department || []);
      } catch (error) {
        console.error("Error fetching form data:", error);
      }
    }
    fetchAllDropdownData();
  }, []);

  const onSubmit = async (data) => {
    try {
      setGlobalLoading(true);
      const formData = new FormData();
      Object.entries(data).forEach(([key, value]) => {
        formData.append(key, value ?? "");
      });

      const response = await axios.post(
        `${API_BASE_URL}/settings/add_designation`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
    //  console.log(response);
      toastr.success("Designation added successfully!");
      onClose();
      setTimeout(() => {
        navigate("/settings/designations");
      }, 1000);

      // setShowModal(false);
    } catch (err) {
      console.error("Submission failed:", err);
      alert("Error updating User.");
    } finally {
      setGlobalLoading(false);
    }
  }; 
   return (
    <div className="modal fade show d-block" tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered modal-md" role="document" style={{ maxWidth: "550px" }}>
        <div className="modal-content">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-header">
              <h4 className="modal-title">Add Designation</h4>
              <button
                onClick={() => onClose()}
                type="button" className="btn-close custom-btn-close"
                data-bs-dismiss="modal" aria-label="Close">
                <i className="ti ti-x"></i>
              </button>
            </div>
            <div className="modal-body row" style={{ textAlign: "left" }}>
              <div className="row">
                <div className="col-md-12 col-sm-12">
                  <div className="mb-2">
                    <label className="form-label">Designation Name *</label>
                    <input type="text" {...register("name", { required: "required" })} className={`form-control ${ errors.name && "is-invalid"}`} />
                  </div>
                  <div className="mb-2">
                    <label className="form-label">Details *</label>
                    <input type="text" {...register("details", { required: "required" })} className={`form-control ${ errors.details && "is-invalid"}`} />
                  </div>
                  <div className="mb-2">
                    <label className="form-label">Sub Department *</label>
                    <select {...register("sub_department_id", {required: "Please select Sub Department",})} className={`form-select ${ errors.sub_department_id && "is-invalid" }`}>
                      <option value="">Select</option>
                      {subDepartment.map((m) => (
                        <option key={m.id} value={m.id}>{m.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button onClick={onClose} type="button" className="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close">
                Close
              </button>
              <button type="submit" className="btn btn-primary ms-2">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
   );  

}    
export default AddDesignation;